<template>
  <div>
    <v-container fluid>
      <v-overlay
        v-model="showSuccess"
        :scrim="true"
        opacity="0.3"
        persistent
        :z-index="9900"
      >
      </v-overlay>
      <transition name="fade-slide">
        <output v-if="showSuccess" class="success-toast">
          <img src="@/assets/mdi_success-bold.svg" alt="img" width="20" height="20" />
          <span style="font-size: 15px; font-weight: 600;">{{ successMessage }}</span>
        </output>
      </transition>

      <v-card class="card pa-4">
        <h1 style="font-weight: 600; font-size: 20px;">{{ $t('consentConfig') }}</h1>
        <v-card class="version-save-container mt-4">
          <v-row class="d-flex align-center control-row">
            <v-col cols="12" sm="6" md="6" class="d-flex align-center justify-start" style="gap: 16px;">
              <div class="text-subtitle-1">{{ $t('versionLabel') }} {{ version || 'N/A' }}</div>

              <!-- Version Selector -->
              <v-autocomplete v-model="viewVersion" :items="listViewVersion" item-title="showVersion" item-value="id"
                :placeholder="$t('viewPreviousVersion')" variant="none"
                density="comfortable" clearable hide-details color="primary"
                class="model-input-control">
                <template v-slot:selection="{ item }">
                  <v-chip color="primary" variant="tonal" size="large" class="ma-1">
                    <template v-slot:prepend>
                      <v-icon size="16" class="mr-2">mdi-tag-outline</v-icon>
                    </template>
                    {{ item.title }}
                  </v-chip>
                </template>

                <template v-slot:item="{ props, item }">
                  <v-list-item v-bind="props" :title="'Version ' + item.raw.showVersion">
                  </v-list-item>
                </template>
              </v-autocomplete>
            </v-col>

            <!-- Save Button -->
            <v-col cols="12" sm="12" md="6" class="d-flex align-center justify-end">
              <button type="button" id="button-updateconsent-consentconfig" class="footer-btn save" @click="updateConsent()">
                <img src="@/assets/basil_save-solid.png" alt="img" width="20" height="20" />
                <span>{{ $t('save') }}</span>
              </button>
            </v-col>
          </v-row>

          <v-overlay v-model="savingIndicator" :scrim="true" opacity="0.3" persistent :z-index="9991" class="align-center justify-center">
            <v-card class="saving-overlay-card" flat>
              <v-card-text class="text-center">
                <v-progress-circular
                  indeterminate
                  size="56"
                  width="4"
                  color="red"
                  class="mb-3"
                />
                <div style="color: #646464;">{{ $t('savingChanges') }}</div>
              </v-card-text>
            </v-card>
          </v-overlay>
        </v-card>
       
        <div class="consent-container mt-8">
          <div class="consent-thai">
            <div class="consent-TH">{{ $t('consentTH') }}</div>
            <div>
              <hr>
            </div>
            <div class="mt-2">
              <EditorJS v-model:content="dataConsentTH" style="overflow-y: auto; height: 100%;" />
            </div>
          </div>

          <div class="consent-eng">
            <div class="consent-EN">{{ $t('consentEN') }}</div>
            <div>
              <hr>
            </div>
            <div class="mt-2">
              <EditorJS v-model:content="dataConsentEN" class="" style="overflow-y: auto; height: 100%;" />
            </div>
          </div>
        </div>
      </v-card>

    </v-container>
    <v-dialog v-model="viewVersion_dialog" max-width="900px">
      <v-card>
        <v-card-title class="d-flex flex-column">
          <h3 style="color: #171717; font-weight: 600;">{{ $t('gpt_model_management_version_history_detail') }}</h3>
          <span style="color: #646464; font-size: 12px;">{{ $t('previewPreviousVersionHistory') }}</span>
        </v-card-title>
        <div class="mt-1">
          <hr>
        </div>
        
        <v-row class="d-flex pa-3 mt-1">
          <v-col cols="12" sm="6" md="6">
            <v-card class="card2">
              <v-card-title style="font-size: 16px;">{{ $t('consentTH') }}</v-card-title>
              <v-card-text>
                <div v-html="viewVersion_consentTH" style="overflow-y: auto; height: 60dvh;"
                  class="data-consent-text"></div>
              </v-card-text>
            </v-card>
          </v-col>
          <v-col cols="12" sm="6" md="6">
            <v-card  class="card2">
              <v-card-title style="font-size: 16px;">{{ $t('consentEN') }}</v-card-title>
              <v-card-text>
                <div v-html="viewVersion_consentEN" style="overflow-y: auto; height: 60dvh;"
                  class="data-consent-text"></div>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>

        <div style="margin-top: -16px;">
          <hr>
        </div>

        <v-card-actions class="mt-2 mb-2">
          <button type="button" class="add-example-section" @click="closeViewVersion()" >
            <img src="@/assets/line-md_close.svg" alt="img" width="16" height="16" />
            <span style="font-weight: 400; font-size: 14px; color: #C30000;">{{ $t('close') }}</span>
          </button>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="showNameRequiredDialog" max-width="460" persistent>
      <v-card class="required-name-dialog" elevation="0">
        <div class="required-name-header">
          <h3 class="required-name-title">{{ $t('consentIsRequired') }}</h3>
          <button type="button" @click="showNameRequiredDialog = false" class="close-btn">
            <img src="@/assets/codex_cross.svg" alt="close" width="24" height="24" style="margin-left: 12px;" />
          </button>
        </div>
        <div class="required-body">
          <p class="required-name-message">{{ requiredConsentMessage }}</p>
        </div>
        <div>
          <hr style="border: none; border-top: 1px solid #c9c9c9;" />
        </div>
        <div class="required-footer">
          <v-btn class="ok-required-btn" @click="showNameRequiredDialog = false" :id="'button-requiredconsent-ok'">{{ $t('ok') }}</v-btn>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import EditorJS from '@/components/EditorJS.vue';
import LogTrace from '@/api/function.js';
// ที่นี่คุณสามารถ import plugins ของ EditorJS ที่ต้องการใช้งาน เช่น:
// import Header from '@editorjs/header';
// import List from '@editorjs/list';
// import Paragraph from '@editorjs/paragraph';

export default {
  name: "ConsentConfig",
  inject: ["flagNav","FontColorTitle","SubNavbarBackGround"],
  mixins: [LogTrace],
  components: { EditorJS },
  data: () => ({
    showNameRequiredDialog: false,
    showSuccess: false,
    successMessage: "",
    _toastTimer: null,
    today: null,
    viewVersion_dialog: false,
    dataConsentTH: "",
    dataConsentEN: "",
    version: "",
    listViewVersion: [],
    viewVersion: null,
    id: null,
    viewVersion_consentTH: "",
    viewVersion_consentEN: "",
    editorTH: null,
    editorEN: null,
    viewEditorTH: null,
    viewEditorEN: null,
    savingIndicator: false,
    editorConfig: {
      holder: '',
      placeholder: 'เริ่มพิมพ์ข้อความที่นี่...',
      tools: {
        // ตัวอย่างการประกาศ plugins (คุณต้องติดตั้งพวกนี้เพิ่มเติม)
        /*
        header: {
          class: Header,
          inlineToolbar: ['link'],
          config: {
            placeholder: 'หัวข้อ'
          },
          shortcut: 'CMD+SHIFT+H'
        },
        paragraph: {
          class: Paragraph,
          inlineToolbar: true
        },
        list: {
          class: List,
          inlineToolbar: true
        }
        */
      },
      data: {
        blocks: []
      }
    },
    editorConfigView: {
      holder: '',
      readOnly: true,
      tools: {}
    }
  }),
  computed: {
    requiredConsentMessage() {
      if (!this.dataConsentTH && !this.dataConsentEN) {
        return this.$t('warningFillConsentThEn');
      } else if (!this.dataConsentTH) {
        return this.$t('warningFillConsentTh');
      } else if (!this.dataConsentEN) {
        return this.$t('warningFillConsentEn');
      }
      return '';
    },
  },
  watch: {
    // viewVersion(value) {
    //     if(value) {
    //         this.viewVersion_dialog = true;
    //     }
    // },
    viewVersion(newId) {
      if (newId) {
        this.changeVersion(newId);
        this.viewVersion_dialog = true;
      }
    },
  },
  methods: {
    Get() {
      this.$call.GetConsentConfig(
        (dataResponse) => {
          if (dataResponse.status == 0 && dataResponse.data) {
            this.dataConsentTH = dataResponse.data.consentTH;
            this.dataConsentEN = dataResponse.data.consentEN;
            this.version = dataResponse.data.showVersion;
          }
          else {
            this.dataConsentTH = "";
            this.dataConsentEN = "";
            this.version = ""
          }
        },
        (errorResource) => {
          console.error(errorResource);
        }
      );

    },
    getViewVersion() {
      this.$call.GetViewVersion(
        (dataResponse) => {
          if (dataResponse.status == 0) {
            this.listViewVersion = dataResponse.data;
          }
          else {
            this.listViewVersion = [];
          }
        },
        (errorResource) => {
          console.error(errorResource);
        }
      );

    },
    updateConsent() {
      if (!this.dataConsentTH || !this.dataConsentEN) {
        this.showNameRequiredDialog = true;
        return;
      }
      try {
        this.savingIndicator = true;
        let temp = {
          ConsentTH: this.dataConsentTH,
          ConsentEN: this.dataConsentEN,
          Version: this.version,
        };

        this.$call.UpdateConsent(
          temp,
          (dataResponse) => {
            if (dataResponse.status == 0) {
              this.successMessage = this.$t('successfullySaved');
              this.showSuccess = true;
              clearTimeout(this._toastTimer);
              this._toastTimer = setTimeout(() => {
                this.showSuccess = false;
              }, 3000);
              this.Get();
              this.getViewVersion();
              this.savingIndicator = false;
            }
          },
          (errorResource) => {
            this.savingIndicator = false;
            console.error(errorResource);
          }
        );
      } catch (error) {
        this.savingIndicator = false;
        this.LogTrace(error, 'Update');
      }
    },
    closeViewVersion() {
      this.viewVersion_dialog = false;
      this.viewVersion = null;
      this.viewVersion_consentTH = "";
      this.viewVersion_consentEN = "";
    },
    changeVersion(id) {
      let temp = {
        ID: id,
      };
      this.$call.GetConsentById(
        temp,
        (dataResponse) => {
          if (dataResponse.status == 0) {
            console.log(dataResponse.data);
            this.viewVersion_consentTH = dataResponse.data.consentTH;
            this.viewVersion_consentEN = dataResponse.data.consentEN;
          }
          else {
            this.viewVersion_consentTH = "";
            this.viewVersion_consentEN = "";
          }
        },
        (errorResource) => {
          console.error(errorResource);
        }
      )
    },
    formatText(text) {
      return text
        .replaceAll('\n', '<br>')
        .replaceAll('\t', '&emsp;')
        .replaceAll(/ {2} /g, '&nbsp;&nbsp;');
    },
  },
  mounted() {
    this.GetDate();
    this.Get();
    this.getViewVersion();
  },
};
</script>
<style scoped>
  .success-toast {
  position: fixed;
  top: 12px;
  left: 50%;
  transform: translateX(-50%);
  background: linear-gradient(100deg,#1D863C,#135928);
  color: #ffffff;
  display: flex;
  align-items: center !important;
  font-size: 14px;
  font-weight: 600;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0,0,0,0.25);
  z-index: 2100;
  width: 50%;
  max-width: 900px;
  min-width: 320px;
  justify-content: center !important;
  padding: 12px;
  border: 1px solid #ffffff;
  gap: 20px;
  margin-top: 80px;
}
.footer-btn {
  border-radius: 10px;
  padding: 4px 10px;
  font-size:13px;
  font-weight:500;
  cursor:pointer;
}
.footer-btn.save {
  display: flex;
  align-items: center;
  justify-content: center !important;
  gap: 8px;
  background: #04B439 !important;
  width: 100px;
  height: 42px !important;
}
.footer-btn.save:hover {
  background: rgba(4, 180, 57, 0.75) !important;
}
.footer-btn.save span {
  font-size: 16px;
  color: #FFFFFF;
}
.required-name-dialog {
  border-radius: 12px !important;
  background: #FFFFFF;
  border: 1px solid #F4D6B8;
}

.required-name-header {
  background: linear-gradient(900deg,#FFF8ED, #FFF0DA);
  padding: 10px 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.required-name-title {
  font-size: 16px;
  font-weight: 600;
  color: #FFA726;
}
.required-body {
  padding: 16px;
}
.required-name-message {
  font-size: 14px;
  color: #171717;
}
.required-footer {
  display:flex;
  justify-content:flex-end;
  padding: 10px 26px;
}
.ok-required-btn {
  border-radius: 10px;
  font-weight:500;
  font-size:13px;
  color: #3f2c00 !important;
  width: 104px;
  background: #FFA726;
}
.required-name-dialog :deep(.v-divider) {
  border-color: #F4D6B8 !important;
}

.required-name-dialog .close-btn {
  color: #B45800;
}

.required-name-dialog .close-btn:hover {
  color: #8C3F00;
}
.card {
  border: 1px solid #c9c9c9;
  border-radius: 10px !important;
  height: 90vh;
  overflow: auto;
  margin: 0 0 2rem 0;
  padding: 0;
  box-shadow: none !important;
}
.text-subtitle-1 {
  font-weight: 600;
  font-size: 16px;
  color: #C32E0E;
}
.version-save-container {
  border: 1px solid #DCDCDC;
  padding: 16px;
  border-radius: 12px;
  box-shadow: none !important;
}
.consent-container {
  display: flex;
  align-items: center;
  justify-content: start;
  gap: 16px;
}
.consent-eng, .consent-thai {
  border: 1px solid #DCDCDC;
  border-radius: 12px;
  box-shadow: none !important;
  width: 50%;
}
.consent-TH, .consent-EN {
  font-size: 16px;
  font-weight: 600;
  padding: 10px 16px !important;
}
.model-input-control :deep(.v-field__append-inner .v-icon) {
  color: #872612 !important;
}
.model-input-control :deep(.v-list .v-list-item--active .v-list-item-title) {
  color: #872612 !important;
  font-weight: 700;
}
.model-input-control :deep(.v-list .v-list-item:hover .v-list-item-title) {
  color: #872612 !important;
}
.model-input-control :deep(.v-field) {
  border: 1px solid #c9c9c9 !important;
  border-radius: 12px !important;
  min-height: 48px;
  box-shadow: none !important;
  background: #ffffff !important;
}
.model-input-control :deep(.v-input__details) {
  display: none;
}
.model-input-control :deep(.v-field__input) {
  padding-top: 13px;
}
.v-dialog > .v-overlay__content > .v-card, .v-dialog > .v-overlay__content > form > .v-card {
  background: #FFFFFF !important;
  border-radius: 10px !important;
  border: 1px solid #CCCCCC;
}
hr {
  border: none;
  border-top: 1px solid #c9c9c9;
}
.card2{
  background: #FFFFFF !important;
  border-radius: 10px !important;
  box-shadow: 0px 2px 22px 0px rgba(23, 23, 23, 0.11);
}
.add-example-section {
  display: flex;
  align-items: center;
  justify-content: center !important;
  border: 1px solid #C32E0E;
  border-radius: 10px;
  gap: 6px;
  padding: 10px;
  width: 100px;
  height: 42px !important;
}
.add-example-section:hover {
  background: rgba(195, 0, 0, 0.1);
}
.saving-overlay-card {
  width: 200px;
  border-radius: 14px;
  background: #ffffff !important;
  box-shadow: 0px 8px 24px rgba(23, 23, 23, 0.18);
  margin-top: -210px;
}
.data-consent-text {
  color: #171717;
  font-size: 15px;
}
.data-consent-text :deep(h1),
.data-consent-text :deep(h1 *) {
  color: #3859D0 !important;
  font-size: 14px !important;
}
.data-consent-text :deep(h2),
.data-consent-text :deep(h2 *) {
  color: #3859D0 !important;
  font-size: 15px !important;
  font-weight: 400 !important;
}

.flex {
  margin: 2rem;
}

.card-1 {
  border-radius: 13px;
  background: #fff;
  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.1);
  width: 100%;
  height: 125px;
  flex-shrink: 0;
}

.formatted-text {
  white-space: pre-wrap;
}

.version-card {
  transition: all 0.2s ease-in-out;
}

.version-card:hover {
  transform: scale(1.02);
  box-shadow: 0 4px 12px rgba(25, 118, 210, 0.15);
}

.modern-select {
  transition: all 0.2s ease-in-out;
}

.modern-select:hover {
  transform: translateY(-1px);
}

.control-row {
  position: relative;
}

.control-row::before {
  content: '';
  position: absolute;
  bottom: -8px;
  left: 0;
  right: 0;
  height: 1px;
  background: linear-gradient(90deg, transparent 0%, rgba(0, 0, 0, 0.1) 50%, transparent 100%);
}

/* Animation for autocomplete */
.v-autocomplete .v-field__input {
  transition: all 0.2s ease-in-out;
}

.v-autocomplete:focus-within .v-field__input {
  transform: translateX(4px);
}

/* Responsive improvements */
@media (max-width: 960px) {

  .save-btn {
    width: 100%;
    margin-top: 1rem;
  }
}

@media (max-width: 600px) {
  .version-card {
    margin-bottom: 1rem;
  }
}
</style>